import { inject, Injectable, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { getStoredTranslationsOrEmpty } from "@app/translation-cache";

@Injectable({ providedIn: "root" })
@Pipe({
  standalone: true,
  name: "mapLanguageName",
})
export class MapLanguageNamePipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  transform(languageCode: string): string {
    const translations = getStoredTranslationsOrEmpty(this.localeId);
    if (translations && translations[`language.${languageCode.toLowerCase()}`]) {
      return translations[`language.${languageCode.toLowerCase()}`];
    }
    return languageCode;
  }
}
